<template>
<v-checkbox hide-details v-model="val" :error="!val && error" off-icon="fal fa-circle">
  <template v-slot:label>
    <div class="text-small">
        {{ mylabel }}
    </div>
  </template>
</v-checkbox>
</template>

<script>
export default {
  name: "ContactCheckbox",

  props: [
    "name",
    "group",
    "label"
  ],

  data() {
    return {
      val: null
    };
  },

  mounted() {
    if (this.group == "contact") {
      this.val = this.$root.contactForm.contact[this.name];
    }
    this.$root.contactForm.registerField(this);
  },

  beforeDestroy() {
    this.$root.contactForm.unregisterField(this);
  },

  computed: {
    invalid() {
      return this.$root.contactForm.errors.indexOf(this.name) > -1;
    },

    required() {
      return this.$root.contactForm.isRequired(this.name);
    },

    mylabel() {
      if (this.required) {
        return `${this.label}*`;
      }

      return this.label;
    },

    error() {
      if (this.invalid) {
        return true;
      }

      return false;
    },

    id() {
      return `contact__${this.name}`;
    }
  },

  methods: {
    mapValue() {
      if (this.group == "contact") {
        this.$root.contactForm.contact[this.name] = this.val;
      } else {
        this.$root.contactForm.contact[this.name] = this.val;
      }
    }
  }
};
</script>
